import { apiClient } from '@/shared/services/api';
import type {
  GetDebriefFactsApiRequest,
  GetDebriefFactsApiResponse,
} from '@momentum/types';

export const debriefV2Service = {
  async getFacts(
    payload: GetDebriefFactsApiRequest
  ): Promise<GetDebriefFactsApiResponse> {
    const response = await apiClient.post<GetDebriefFactsApiResponse>(
      '/debrief-v2/facts',
      payload,
      { timeout: 300_000 }
    );
    return response.data;
  },
};
